import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import styled from "styled-components";
import Canvas from "./Canvas";
import Queue from "./Queue";
import History from "./History";
import Bet from "./Bet";
import { Helmet } from "react-helmet";
import BankRoll from "../../Components/Game/BankRoll";
import { wait, Event } from "../../../Helper";
import Help from "./Help";
import Engine from "./Engine";
import Loading from "../Loading";
import BetsPopKeno from "./Graph";

// Styled Components for responsiveness
const GameContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  animation: fadeIn 0.5s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;

  @media (max-width: 1370px) {
    flex-direction: column;
  }
`;

const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const SideContent = styled(Card)`
  // margin-top: 20px;
  margin-bottom: 0;
  width: 100%;
  max-width: 450px;
  @media (max-width: 1370px) {
    width: 100%;
    max-width: 100%;
  }
`;

const BottomCard = styled(Card)`
  margin-top: 20px;
  margin-bottom: 0;
`;

const FooterCard = styled(Card)`
  margin-bottom: 0;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  background-color: #17181b;
  border-top: 2px solid #1f2125;
`;

const ActionButton = styled.div`
  cursor: pointer;
  margin-right: 0.5rem;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 15px;
  justify-content: space-between;

  @media (max-width: 576px) {
    gap: 10px;
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
`;

class Game extends React.Component {
  _Mounted = false;
  constructor(props) {
    super(props);
    this.state = {
      engine: new Engine(),
      mobile: false,
      padding: "p-1",
      showPopup: false,
    };
    this.handleResize = this.handleResize.bind(this);
    this.handleShowPopUp = this.handleShowPopUp.bind(this);
  }

  componentDidMount() {
    let { engine } = this.state;

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    // Start Engine
    engine.started = true;

    wait(600).then(() => {
      this._Mounted = true;
      this.handleResize();
    });
    window.addEventListener("resize", this.handleResize);

    if (this.isMobile()) {
      this.setState({ height: "unset", mobile: true });
    } else {
      this.setState({ height: this.getHeight(), mobile: false });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    this._Mounted = false;

    let { engine } = this.state;

    // Stop Engine
    engine.started = false;
    engine.trigger = null;
    engine.off();
  }

  handleResize() {
    if (this.getWidth() < 1540) {
      this.setState({ col: "col-xl-12" });
      Event.emit("hide_games");
    } else {
      this.setState({ col: "col-md-12" });
      Event.emit("show_min_games");
    }

    if (this.isMobile()) {
      this.setState({ mobile: true, ovh: "ovh", padding: "p-0" });
    } else {
      this.setState({ mobile: false, padding: "p-1" });
    }
  }

  handleShowPopUp() {
    this.setState((prevState) => ({
      showPopup: !prevState.showPopup,
    }));
  }

  getHeight() {
    return document.documentElement.clientHeight || document.body.clientHeight;
  }

  getWidth() {
    return document.documentElement.clientWidth || document.body.clientWidth;
  }

  isMobile() {
    return this.getWidth() < 992;
  }

  render() {
    let { engine, col, ovh, padding } = this.state;
    return (
      <>
        <Helmet>
          <title>Keno</title>
          <link rel="canonical" href="/keno" />
        </Helmet>
        <div>
          {this._Mounted ? (
            <GameContainer className={`${col} ${padding}`}>
              {this.state.showPopup && (
                <ModalOverlay>
                  <BetsPopKeno onClose={this.handleShowPopUp} engine={engine} />
                </ModalOverlay>
              )}
              <Row className={`animated fadeIn ${ovh || ""}`}>
                <Col sm={12} className={`m-auto ${col} ${padding}`}>
                  <ContentWrapper>
                    <MainContent>
                      <Canvas engine={engine} />

                      <BottomCard>
                        <Card.Body style={{ padding: "0px" }}>
                          <Row>
                            <Col sm={12} md={12} className="text-left m-auto">
                              <Bet engine={engine} mobile={this.state.mobile} />
                            </Col>
                          </Row>
                        </Card.Body>
                      </BottomCard>

                      <FooterCard>
                        <Card.Body className="px-2 py-3">
                          <Row>
                            <Col xs={6} md={6} className="text-left">
                              <BankRoll game={"keno"} />
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                              <ButtonsContainer>
                                <ActionButton onClick={this.handleShowPopUp}>
                                  <img
                                    style={{ height: "20px", width: "20px" }}
                                    src="/assets/images/nanoicons/nanoswap.png"
                                    alt="Swap"
                                  />
                                </ActionButton>
                                <History engine={engine} />
                                <Help />
                              </ButtonsContainer>
                            </Col>
                          </Row>
                        </Card.Body>
                      </FooterCard>
                    </MainContent>

                    <SideContent>
                      <Card.Body className="py-0 px-2">
                        <Queue game={"keno"} engine={engine} t={this.props.t} />
                      </Card.Body>
                    </SideContent>
                  </ContentWrapper>
                </Col>
              </Row>
            </GameContainer>
          ) : (
            <Loading />
          )}
        </div>
      </>
    );
  }
}

export default Game;
